module.exports = __webpack_public_path__ + "static/d4-98ea38c75e941aa0422bffdc0c3d2759.png";